import clsx from "clsx";

interface RootLayoutProps {
  children: React.ReactNode;
  title: string;
}

const RootLayout = ({ children, title }: RootLayoutProps) => {
  return (
    <div className="h-screen w-screen">
      <header
        className={clsx(
          "h-28 fixed right-0 left-0 z-10",
          "border-t-[5px] border-t-[#FF9966] border-b-[5px] border-b-[#FF6666]"
        )}
      >
        <img
          src="/img/rectangle-1.png"
          alt="header"
          className="w-full h-full"
        />
        <div
          className={clsx(
            "absolute bottom-3 right-7 h-7 w-[154px]",
            "flex items-center justify-center",
            "bg-[#9F0050] text-white text-sm rounded-xl"
          )}
        >
          基隆親子照護平台
        </div>
      </header>
      <main className="pt-28 min-h-[calc(100%-32px)]">
        <nav className="h-10 px-6 flex items-center bg-[#C83862] text-white text-2xl">
          {title}
        </nav>
        <main>{children}</main>
      </main>
      <footer
        className={clsx(
          "h-8 sticky left-0 right-0 bottom-0",
          "flex items-center justify-center",
          "bg-[#FCE4EC] text-[#00000080] text-sm"
        )}
      >
        © 2024 基隆市衛生局
      </footer>
    </div>
  );
};

export default RootLayout;
